export default __webpack_public_path__ + "static/media/AA Posters_3_Web Size.a04a0b98.jpg";